import axios from "axios";
import { useNavigate } from "react-router-dom";



class Axios {
    async get(url) {
        try {
            var config = {
                method: 'get',
                url: url,
                headers: setHeaders()
            };
            return await axios(config)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        return (response.data);
                    }

                    else {
                        return (response.data);
                    }
                })
                .catch((error) => {
                    console.log("error", error)
                    if (error.response.status === 401) {
                        window.location.replace("/login");
                        localStorage.setItem("AccessToken", "")
                        return (error);
                    } else {
                        return (error);
                    }
                });
        } catch (error) {
            return handleErrors(error);
        }
    }

    async post(url, data) {
        try {
            var config = {
                method: 'post',
                url: url,
                data: data,
                headers: setHeaders()
            };
            return await axios(config)
                .then((response) => {
                    return (response.data);
                })
                .catch(async (error) => {
                    return (error.response.data)
                });
        } catch (error) {
            return handleErrors(error);
        }
    }

    async put(url, data) {
        try {
            var config = {
                method: 'put',
                url: url,
                data: data,
                headers: setHeaders()
            };
            return await axios(config)
                .then((response) => {
                    return (response.data);
                })
                .catch((error) => {
                    console.log("putERROR2", error)
                    return handleErrors(error.response.data.errors, error.response.data.message);
                });

        } catch (error) {
            return handleErrors(error);
        }
    }

    async patch(url, data) {
        try {
            var config = {
                method: 'patch',
                url: url,
                data: data,
                headers: setHeaders()
            };

            return await axios(config)
                .then((response) => {
                    return (response.data);
                })
                .catch((error) => {
                    return handleErrors(error);
                });
        } catch (error) {
            return handleErrors(error);
        }
    }

    async delete(url, data) {
        try {

            var config = {
                method: 'delete',
                url: url,
                data: data,
                headers: setHeaders()
            };

            return await axios(config)
                .then((response) => {
                    return (response.data);
                })
                .catch((error) => {
                    return handleErrors(error);
                });

        } catch (error) {
            return handleErrors(error);
        }
    }

}

export default new Axios();



function setHeaders() {

    if (localStorage.getItem("AccessToken")) {
        return {
            Authorization: "Bearer " + localStorage.getItem("AccessToken"),
        };
    } else {
        return {
            'Content-Type': 'application/json',
        };
    }

}
// function buildResponse(response) {
//     return {
//         data: response.data ? response.data : {},
//         statusCode: response.status,
//         status: true,
//         statusText: (response.statusText && response.statusText != "") ? response.statusText : "success",
//         message: response.data.message ? response.data.message : "request was successful.",
//     }
// }
// function buildPostResponse(response) {
//     return {
//         data: response.data.data ? response.data.data : {},
//         statusCode: response.status,
//         status: true,
//         statusText: (response.statusText && response.statusText != "") ? response.statusText : "success",
//         message: response.data.message ? response.data.message : "request was successful.",
//     }
// }
function handleErrors(error) {
        console.log('ApiError',error)
        if(error.response.status ==401){
            localStorage.removeItem("AccessToken")
            window.location.replace('/login')
        }
}
 